module.exports = __webpack_public_path__ + "img/img_tyle.fef48223.png";